import Link from '@ramsey-design-system/link';
import { useWindowSize } from '../../../shared/hooks';

function ProJoinOurProgram() {
  const { width } = useWindowSize();

  return (
    <p className="mt-4 text-3 sm:text-4 leading-lg text-center">
      Are you a tax pro?{' '}
      <Link
        href="https://www.ramseysolutions.com/taxes/tax-pro?campaign_name=Trusted_B2B_Tax_B2C_Transitional_CTA"
        size={width > 599 ? 'large' : 'medium'}
        className="!underline"
        target="_blank"
        data-testid="tax_b2b_link"
      >
        Join{'\u00A0'}our{'\u00A0'}program
      </Link>
      .
    </p>
  );
}

export { ProJoinOurProgram };
